import script from "./SandBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SandBox.vue?vue&type=script&setup=true&lang=js"

import "./SandBox.vue?vue&type=style&index=0&id=121795ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121795ef"]])

export default __exports__